import * as React from "react";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";
import DualRange from "../DualRange";
import SelectTeam from "../SelectTeam-new/SelectTeam";
import Textarea from "../Textarea-new/Textarea";
import { getTenantSubcategoryOptions } from "../../utils";
import Checkbox from "../CheckboxNew/Checkbox";
import { STATUS_1031_BUYER } from "../../investor-status";
import { dateToString } from "../../date-converter";

import moment from "moment";
//Note:Here i took the classname Buyer-info because it will be the same as earlier buyer screen
const InvestorInfo = ({
  data,
  handleChangeInput,
  handleChangeDropdown,
  isExists,
  viewMode,
  deleted,
  toggleDrawer,
  handleParentDropdownChange,
  formatDate,
  typeDuplicate
}) => {
  const selectedTypes = data.type ? String(data.type).split(",") : [];
  const showSubcategorySTNL = selectedTypes.includes("STNL") && !!data.category;
  const showSubcategoryMT = selectedTypes.includes("MT") && !!data.category;
  const bothSubcategories = showSubcategorySTNL && showSubcategoryMT;
  return (
    <div className="Buyer-info">
      <div className="Buyer-info_column">
      {(isExists) && <p className="errorText"> {typeDuplicate ? typeDuplicate : "Given Investor Details Already Exists"}</p>}
      <div className="hotlist_name_section">
          <div className="Buyer-info_column_hotlist_name_label">
              <label>First Name</label>
              <Checkbox 
                  text="AthCap - Hot List"
                  type={viewMode ? "uncheckable" : "checkable"}
                  isSelected={data.hsc_hot_list === "1"} 
                  handleClick={() => handleChangeInput("hsc_hot_list")} 
                  name="hsc_hot_list"
                  viewMode={viewMode}
              />  
          </div>
          <Input
            className="Buyer-info_column_item"
            required
            valueType="text"
            name="first_name"
            value={data.first_name}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />
          
          </div> 

        {/* <Input
          className="Buyer-info_column_item"
          required
          valueType="text"
          name="first_name"
          label="First Name"
          value={data.first_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        /> */}
        <Input
          className="Buyer-info_column_item"
          required
          valueType="text"
          name="last_name"
          label="Last Name"
          value={data.last_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-info_column_item"
          valueType="phone"
          name="phone"
          label="Work Phone"
          value={data.phone}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-info_column_item"
          required={data.contact_type && data.contact_type.includes("Team")}
          valueType="phone"
          name="cell_phone"
          label="Cell Phone"
          value={data.cell_phone}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-info_column_item"
          valueType="email"
          name="email"
          label="Email"
          value={data.email}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Dropdown
          className="Buyer-info_column_item"
          data={data}
          optionsType="profiles"
          value={data.profile}
          valueKey="profile"
          label="Profile"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Dropdown
          className="Buyer-info_column_item"
          data={data}
          optionsType="investorStatus"
          value={data.status}
          valueKey="status"
          label="Investor Status"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
        {(data.status === STATUS_1031_BUYER || data.date_of_down_leg) && (
          <Input
            className="Buyer-info_column_item"
            type="date"
            max={dateToString(new Date())}
            required={data.status === STATUS_1031_BUYER}
            name="date_of_down_leg"
            label="Date of Down Leg"
            value={
              viewMode && data.date_of_down_leg
                ? moment(data.date_of_down_leg, "YYYY-MM-DD").format("MM/DD/YYYY")
                : data.date_of_down_leg
            }
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />
        )}
          <Dropdown
          className="Buyer-info_column_item"
          dropdownType='multiple'
          optionsType='contactType'
          value={Array.isArray(data.contact_type) ? data.contact_type.join(",") : data.contact_type || ""}
          valueKey='contact_type'
          label='Contact Type'
          data={data}
          handleParentChange={handleParentDropdownChange}
          viewMode={viewMode}
        />
       {data.contact_type && (data.contact_type.includes("Lender")) ?
          <Input
            className="Buyer-info_column_item"
            name="name"
            required
            label="Company"
            value={data.name}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />
          : ""
        }
        <div
          className={`Buyer-info_column_item last-modified ${
            deleted ? "deleted" : ""
          }`}
        >
       Last modified on:
          {data.arcimedes_modified
            ? formatDate
              ? moment(data.arcimedes_modified).format("MM/DD/YYYY")
              : data.arcimedes_modified
            : " "}
          {/* {formatDate ? moment(+data.last_modified).format("MM/DD/YYYY") : data.last_modified} if data.modified is null then +null become 0 and moment(0) creates a Moment date from the Unix timestamp 0, which is 01/01/1970 UTC.*/} 
        </div>
      </div>
      <div className="Buyer-info_column">
        {data.status && (
          <React.Fragment>
            <Dropdown
              className="Buyer-info_column_item"
              dropdownType="multiple"
              optionKey="code"
              optionLabelKey="name"
              data={data}
              optionsType="category"
              value={data.category}
              valueKey="category"
              label="Category"
              handleParentChange={handleChangeDropdown}
              viewMode={viewMode}
              deleted={deleted}
            />
            <Dropdown
              className="Buyer-info_column_item"
              optionKey="code"
              dropdownType="multiple"
              optionLabelKey="name"
              data={data}
              optionsType="type"
              value={data.type}
              valueKey="type"
              label="Type"
              handleParentChange={handleChangeDropdown}
              viewMode={viewMode}
              deleted={deleted}
            />
            
            {
                showSubcategorySTNL &&
                <Dropdown
                  className="Buyer-info_column_item"
                  dropdownType="multiple"
                  data={data}
                  options={getTenantSubcategoryOptions("STNL", data.category)}
                  optionsType="subcategorySTNL"
                  value={data.single_tenant_subcategory}
                  valueKey="single_tenant_subcategory"
                  label={bothSubcategories ? "Single-Tenant Subcategory" : "Tenant Subcategory"}
                  handleParentChange={handleChangeDropdown}
                  viewMode={viewMode}
                  deleted={deleted}
                />
            }
            {
                showSubcategoryMT &&
                <Dropdown
                  className="Buyer-info_column_item"
                  dropdownType="multiple"
                  data={data}
                  options={getTenantSubcategoryOptions("MT", data.category)}
                  optionsType="subcategoryMT"
                  value={data.multi_tenant_subcategory}
                  valueKey="multi_tenant_subcategory"
                  label={bothSubcategories ? "Multi-Tenant Subcategory" : "Tenant Subcategory"}
                  handleParentChange={handleChangeDropdown}
                  viewMode={viewMode}
                  deleted={deleted}
                />
            }
        
            <Dropdown
              className="Buyer-info_column_item"
              dropdownType="multiple"
              data={data}
              optionsType="buyer-market"
              value={data.market}
              valueKey="market"
              label="Market"
              handleParentChange={handleChangeDropdown}
              viewMode={viewMode}
              deleted={deleted}
            />
            <DualRange
              className="Buyer-info_column_item"
              minValue={data.price_min}
              maxValue={data.price_max}
              minName="price_min"
              maxName="price_max"
              valueType="integer"
              label="Price Range"
              handleParentChange={handleChangeInput}
              viewMode={viewMode}
              deleted={deleted}
              isDollar
            />
            <DualRange
              className="Buyer-info_column_item"
              minValue={data.cap_rate_min}
              maxValue={data.cap_rate_max}
              minName="cap_rate_min"
              maxName="cap_rate_max"
              valueType="percent"
              label="Cap Rate Range"
              handleParentChange={handleChangeInput}
              viewMode={viewMode}
              deleted={deleted}
            />
            <SelectTeam
              className="Buyer-info_column_item"
              value={data.strive_agent}
              valueKey="strive_agent"
              label="Agent"
              data={data}
              handleParentChange={handleChangeDropdown}
              viewMode={viewMode}
              deleted={deleted}
            />
            {/* <Textarea
              className="Buyer-info_column_item"
              label="Notes"
              name="notes"
              value={data.notes}
              maxWidth="100%"
              handleParentChange={handleChangeInput}
              viewMode={viewMode}
              deleted={deleted}
              required={data.contact_type && (data.contact_type.includes("Lender"))}
            /> */}
          </React.Fragment>
        )}
        {/* {!data.status && data.contact_type && (data.contact_type.includes("Lender")) &&
         <Textarea
         className="Buyer-info_column_item"
         label="Notes"
         name="notes"
         value={data.notes}
         maxWidth="100%"
         handleParentChange={handleChangeInput}
         viewMode={viewMode}
         deleted={deleted}
         required={data.contact_type && (data.contact_type.includes("Lender"))}
       />
      } */}
       {data.status && data.status.toLowerCase() === "off-market" &&
        <div className="Seller-info_button button-new positive" onClick={toggleDrawer}>Add Property</div>
        }
      </div>
    </div>
  );
};

export default InvestorInfo;
